import { Roles, useIdentityUser, useRolesMatch } from '@/js/libs/use-auth';

import { useCompanySwitchContext } from 'src/modules/CompaniesSwitch/context.tsx';

// Opens the admin access history to platform admins, who see every temporary access session, and to users of a
// company that requires temporary access, who see their company's. It stays closed while a company is selected in
// the switcher, where the viewed company's temporaryAccessRequired would otherwise let the viewer in.
export const useCanViewAdminAccessHistory = (): boolean => {
  const isAdmin = useRolesMatch({ roles: Roles.ADMIN });
  const isTemporaryAccessRequired = Boolean(useIdentityUser()?.company.temporaryAccessRequired);
  const switchedCompany = useCompanySwitchContext('company');

  return (isAdmin || isTemporaryAccessRequired) && !switchedCompany;
};
